export const resourcesHr = {
  Common: {
    AppName: 'Digital Escape Room',
    Dashboard: 'Dashboard',
    Players: 'Igrači',
    Edit: 'Uredi',
    Settings: 'Postavke',
    Actions: 'Akcije',
    Delete: 'Obriši',
    Loading: 'Učitavanje...',
    Cancel: 'Odustani'
  },
  Buttons: {
    Open: 'Otvori',
    Login: 'Prijavi se',
    Logout: 'Odjava',
    Save: 'Spremi',
    SaveDraft: 'Spremi trenutne postavke',
    SaveAsQuiz: 'Spremi kao kviz',
    LoadQuiz: 'Učitaj kviz',
    StartGame: 'Pokreni igru',
    ResumeGame: 'Nastavi igru',
    PauseGame: 'Pauziraj igru',
    StopGame: 'Zaustavi igru',
    Reset: 'Reset',
    Start: 'Počni',
    ConfirmSelection: 'Potvrdi odabir',
    UnlockNextRound: 'Otključaj idući krug',
    Check: 'Provjeri',
    CheckGameCompletion: 'Provjeri završetak igre',
    Continue: 'Nastavi',
    Upload: 'Učitaj',
    AddQuestionSet: 'Dodaj novi set pitanja'
  },
  Admin: {
    Layout: {
      Title: 'Digital Escape Room Admin',
      Nav: {
        GameSettings: 'Postavke igre',
        Questions: 'Pitanja',
        Quizzes: 'Kvizovi',
        GlobalSettings: 'Opće postavke'
      }
    },
    Dashboard: {
      GameSettingsTitle: 'Postavke igre',
      GameSettingsText: 'Podesite natjecatelje, naslov, uvod i dinamičke krugove.',
      QuestionsTitle: 'Pitanja',
      QuestionsText: 'Kreirajte setove pitanja i uređujte pitanja unutar svakog seta.',
      QuizzesTitle: 'Kvizovi',
      QuizzesText: 'Spremite, učitajte i brišite spremljene konfiguracije kviza.',
      GlobalSettingsTitle: 'Opće postavke',
      GlobalSettingsText: 'Učitajte logotip i zvukove za točan, netočan i završen krug.'
    },
    Login: {
      Title: 'Admin prijava',
      Username: 'Korisničko ime',
      Password: 'Lozinka'
    },
    GameSettings: {
      Title: 'Postavke igre',
      Basics: 'Osnovne postavke',
      QuizName: 'Ime kviza',
      QuizNameHelp: 'Ime kviza koristi se za spremanje i kasnije ponovno učitavanje kviza.',
      QuizPublicTitle: 'Naslov kviza',
      IntroText: 'Uvodni tekst',
      ShowLogo: 'Prikaži logotip',
      CorrectSound: 'Zvuk točnog odgovora',
      WrongSound: 'Zvuk netočnog odgovora',
      WrongDelay: 'Pauza nakon netočnog odgovora',
      WrongDelayDuration: 'Dužina pauze',
      PlayerCount: 'Broj natjecatelja',
      Rounds: 'Krugovi',
      RoundTitle: 'Naslov kruga',
      QuestionSet: 'Set pitanja',
      QuestionsPerPlayer: 'Broj pitanja po igraču',
      SecretWord: 'Tajna riječ za otključavanje',
      SecretWordLastRound: 'Tajna riječ (nije potrebna za zadnji krug)',
      RoundCompletionMessage: 'Poruka nakon završetka kruga',
      SaveSection: 'Spremanje postavki',
      RuntimeControls: 'Kontrole igre',
      RuntimeStatus: 'Status i log igre',
      WaitingFor: 'Čeka se',
      ActivityLog: 'Dnevnik aktivnosti',
      NoEvents: 'Još nema događaja za prikaz.',
      SecondsOption: '{seconds} sekundi',
      RoundNumber: 'Krug {number}',
      RoundCompletedDefault: 'Čestitamo! Završili ste krug.',
      AddRound: 'Dodaj krug',
      RemoveRound: 'Ukloni krug',
      SaveSectionDescription: 'Spremite konfiguraciju kviza prije pokretanja igre ili nakon izmjena u formi.',
      EditingQuiz: 'Uređujete kviz: {name}',
      SaveDraftHint: 'Sprema trenutno uređene postavke igre.',
      SaveQuizHint: 'Sprema ove postavke kao kviz koji kasnije možete učitati.',
      SelectSavedQuiz: 'Odaberite spremljeni kviz',
      LoadQuizHint: 'Učitava već spremljeni kviz u trenutne postavke igre.',
      LastSaveAction: 'Zadnja akcija spremanja: {message} ({time})',
      RuntimeStatusLine: 'Status igre: {status} · Faza: {phase}',
      LastRuntimeAction: 'Zadnja akcija: {message} ({time})',
      CurrentStatus: 'Trenutni status',
      CurrentlySolving: 'Trenutno rješavaju: {value}',
      FinishedCurrentRound: 'Završili trenutni krug: {value}',
      PlayersStatus: 'Status natjecatelja',
      PlayerFinished: 'završio',
      PlayerActive: 'aktivan',
      PlayerNotJoined: 'nije prijavljen',
      WaitingForValue: 'Čeka se: {value}',
      SaveDraftSuccess: 'Trenutne postavke igre su spremljene.',
      SaveDraftError: 'Spremanje postavki nije uspjelo. Pokušajte ponovno.',
      SaveQuizNameRequired: 'Unesite ime kviza prije spremanja kviza.',
      SaveQuizSuccess: 'Kviz "{name}" je spremljen i dostupan u sekciji Kvizovi.',
      SaveQuizError: 'Spremanje kviza nije uspjelo.',
      LoadQuizError: 'Učitavanje kviza nije uspjelo.',
      StartSuccess: 'Igra je uspješno pokrenuta.',
      StartError: 'Pokretanje igre nije uspjelo.',
      PauseSuccess: 'Igra je pauzirana.',
      PauseError: 'Pauziranje igre nije uspjelo.',
      StopSuccess: 'Igra je zaustavljena.',
      StopError: 'Zaustavljanje igre nije uspjelo.',
      ResetSuccess: 'Igra je vraćena na početno stanje.',
      ResetError: 'Reset igre nije uspio.'
    },
    SavedQuizzes: {
      Title: 'Kvizovi',
      Description: 'Spremljeni kvizovi su prethodno spremljene postavke igre koje možete ponovno otvoriti i urediti.',
      QuizName: 'Naziv kviza',
      QuizTitle: 'Naslov',
      PlayerCount: 'Broj igrača',
      Rounds: 'Krugovi',
      Deleted: 'Kviz je obrisan.'
    },
    GlobalSettings: {
      Title: 'Opće postavke',
      Logo: 'Logotip',
      CorrectSound: 'Zvuk točnog odgovora',
      WrongSound: 'Zvuk netočnog odgovora',
      RoundCompleteSound: 'Zvuk uspješno završenog kruga',
      FileUploaded: 'Datoteka je uspješno učitana.',
      FileDeleted: 'Datoteka je obrisana.',
      FileAdded: 'Dodana datoteka: {fileName}',
      FileMissing: 'Datoteka nije dodana.',
      LogoAlt: 'Logo'
    },
    QuestionSets: {
      Title: 'Pitanja',
      SetsTitle: 'Setovi pitanja',
      Name: 'Naziv',
      QuestionCount: 'Broj pitanja',
      SelectSetPrompt: 'Odaberite set pitanja za uređivanje.',
      NoNote: 'Nema napomene.',
      SavedSet: 'Set pitanja je spremljen.',
      SavedQuestion: 'Pitanje je spremljeno.',
      DeletedSet: 'Set pitanja je obrisan.',
      DeletedQuestion: 'Pitanje je obrisano.',
      EditQuestion: 'Uredi pitanje',
      AddQuestion: 'Dodaj pitanje',
      QuestionTypeTf: 'Točno / Netočno',
      Question: 'Pitanje'
      ,
      Type: 'Vrsta',
      TypeTfCompact: 'Točno/Netočno',
      AnswerOption: 'Odgovor {key}',
      CorrectAnswerOption: 'Točan odgovor: {key}',
      StatementTrue: 'Tvrdnja je točna',
      StatementFalse: 'Tvrdnja je netočna',
      SaveQuestion: 'Spremi pitanje',
      EditSet: 'Uredi set pitanja',
      AddQuestionSetDialog: 'Dodaj novi set pitanja',
      SetNameLabel: 'Naziv seta pitanja',
      NoteLabel: 'Napomena'
    }
  },
  Player: {
    Header: {
      LogoAlt: 'Logo kviza'
    },
    Intro: {
      WelcomeFallback: 'Dobrodošli u kviz.',
      PlayersLabel: 'Igrači: {value}',
      PlayersSummary: '{joined} prijavljena od ukupno {enabled} uključenih natjecatelja.',
      NameLabel: 'Unesi svoje ime',
      JoinUnavailable: 'Prijava trenutno nije moguća.',
      ResetMessage: 'Nema trenutno otvorenih kvizova. Pričekajte administratora da pokrene kviz.'
    },
    Flow: {
      StoppedReasonFallback: 'Igra je zaustavljena od strane administratora.',
      JoinedWaitStart: 'Uspješno ste prijavljeni. Pričekajte pokretanje kviza.',
      JoinQuotaReached: 'Sva mjesta za ovaj kviz su popunjena.',
      JoinNotOpen: 'Prijava nije otvorena. Administrator prvo mora pokrenuti kviz.',
      PausedTitle: 'Igra je trenutno pauzirana.',
      PausedMessage: 'Pričekajte da administrator nastavi igru.',
      JoinedTitle: 'Uspješno ste prijavljeni.',
      JoinedWaitingMessage: 'Čekamo da se svi natjecatelji priključe pa igra počinje.'
    },
    Question: {
      RoundQuestionLabel: 'KRUG {round} PITANJE {progress}/{total}',
      SelectCorrectAnswer: 'Odaberi točan odgovor:',
      True: 'Točno',
      False: 'Netočno',
      LockWait: 'Pričekajte {seconds} s prije novog pokušaja.'
    },
    Waiting: {
      Title: 'Točno ste odgovorili na sva pitanja.',
      Message: 'Čekamo da i ostali natjecatelji završe.'
    },
    RoundComplete: {
      Congrats: 'Čestitamo!',
      PreparingUnlock: 'Pripremamo otključavanje idućeg kruga...'
    },
    Unlock: {
      Prompt: 'Da biste otključali idući krug, unesite tajnu riječ.',
      SecretWordLabel: 'Tajna riječ'
    },
    Stopped: {
      Title: 'Igra je zaustavljena.'
    },
    Finished: {
      Title: 'Igra je završena'
    },
    Portal: {
      IntroJoinTitle: 'Prijava natjecatelja',
      IntroWelcomeTitle: 'Dobro došli',
      SelectPlayer: 'Odaberite natjecatelja',
      PlayerLabel: 'Natjecatelj {number}',
      PlayerDisabled: 'Odabrani natjecatelj nije uključen u ovoj igri.',
      JoinAsPlayer: 'Prijavi se kao Natjecatelj {number}',
      IdleInfo: 'Igra još nije pokrenuta. Pričekajte administratora.',
      StoppedInfo: 'Igra je trenutno zaustavljena.',
      StoppedTitle: 'Igra je zaustavljena',
      RoundLabel: 'KRUG {number}',
      QuestionLabel: 'PITANJE {current}/{total}',
      SelectCorrectAnswer: 'Odaberite točan odgovor:',
      LockWait: 'Pričekajte {seconds} s prije novog pokušaja.',
      WaitingRoundTitle: 'Krug',
      WaitingEyebrow: 'Pitanje',
      WaitingDone: 'Točno ste odgovorili na sva pitanja ovog kruga.',
      WaitingOthers: 'Čekamo da i ostali natjecatelji završe!',
      WaitingStill: 'Svi natjecatelji još uvijek nisu odgovorili na sva pitanja. Pokušajte uskoro.',
      CongratsUpper: 'ČESTITAMO!',
      CompletionFallback: 'Čestitamo!',
      UnlockTitle: 'Otključavanje sljedećeg kruga',
      UnlockPrompt: 'Da biste otključali idući krug, unesite tajnu riječ.',
      UnlockButton: 'Otključaj {title}',
      UnlockDefaultNextRound: 'sljedeći krug',
      UnlockedTitle: 'Sljedeći krug je otključan',
      UnlockedMessage: 'Uspješno ste otključali krug “{title}”. Kliknite {continueLabel} kako biste krenuli dalje.',
      FinishedTitle: 'Igra je završena'
    }
  },
  Status: {
    Idle: 'Nije pokrenuta',
    Reset: 'Resetirana',
    Running: 'Pokrenuta',
    Stopped: 'Zaustavljena',
    Paused: 'Pauzirana',
    Completed: 'Završena'
  },
  Messages: {
    GenericActionFailed: 'Akcija nije uspjela.',
    GenericActionSuccess: 'Akcija je uspješno izvršena.',
    RoundAllFinished: 'Svi natjecatelji su završili trenutni krug.',
    NoOne: 'nitko',
    Event: 'Događaj',
    StatusGame: 'Status igre: {value}',
    CurrentRound: 'Trenutni krug: {value}',
    Phase: 'Faza: {value}',
    ActiveQuiz: 'Aktivni kviz: {value}',
    EnabledPlayers: 'Uključeni natjecatelji: {count}',
    JoinedPlayers: 'Prijavljeni natjecatelji: {joined}/{enabled}'
  }
};
